module.exports = __webpack_public_path__ + "static/partnership_process_obj01@2x-7a30ed5a8d80da8c0077446891b7f93a.png";